export const isNumber = (value: unknown): value is number =>
    value != null &&
    value !== '' &&
    !(typeof value === 'string' && value.trim().startsWith('.')) &&
    !(typeof value === 'string' && value.trim().endsWith('.')) &&
    !isNaN(Number(value.toString()));
